<template>
  <div class="success-content">
    <font-awesome-icon class="success-icon" :icon="'thumbs-up'" />
    <h1 class="success-title">Seu boleto bancário foi emitido com sucesso!</h1>

    <p class="success-text">Clique no botão abaixo para visualizar o boleto.</p>

    <a :href="billet" class="button" role="button"><span>Baixar o boleto bancário</span></a>

    <ButtonStores />
  </div>
</template>

<script>
import ButtonStores from '@/components/buttons/ButtonStores.vue';

export default {
  name: 'SuccessDefault',
  components: { ButtonStores },
  data() {
    return {
      message: sessionStorage.getItem('paid'),
      billet: sessionStorage.getItem('bankslipUrl')
    };
  },
  mounted() {
    if (!sessionStorage.getItem('paid')) {
      this.$router.push({
        name: 'register'
      });
    }
  }
};
</script>
